import { ChevronUpIcon } from "@radix-ui/react-icons";

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  children?: React.ReactNode;
}

export function EmptyState({
  icon = <ChevronUpIcon className="h-8 w-8 text-muted-foreground" />,
  title,
  description,
  children,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-24 space-y-6 text-center">
      <div className="rounded-full bg-muted p-4 w-fit">{icon}</div>
      <div className="space-y-2">
        <h2 className="text-xl font-bold tracking-tight font-display">
          {title}
        </h2>
        <p className="text-sm text-muted-foreground max-w-sm">{description}</p>
      </div>
      {children}
    </div>
  );
}
